import {
	handleChange,
	resetForm,
	setCollection,
	setSortingValues,
	setSubCollection,
} from 'feature/form/formSlice';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { AppDispatch, RootState } from 'store/store';
import { claimStatusIds } from 'types/Claims';
import { Collections, sortingDirections, SubCollections } from 'types/Form';
import { PATHNAMES } from 'utils/constants';

export const useGetClaimStatusProperty = () => {
	const { claimsStatuses } = useSelector((store: RootState) => store.form);
	const getClaimStatus = (statusId: claimStatusIds) => {
		return (
			claimsStatuses.find(el => el.id === statusId) || {
				id: 0,
				name: '',
				label: '',
				groupCode: '',
				groupLabel: '',
				reasonCode: '',
				reasonCodeLabel: '',
			}
		);
	};

	return {
		getClaimStatus,
	};
};

export const useResetPage = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { pathname: currentPath } = useLocation();

	const currentPathStart = window.location.pathname.split('/')[1];
	const [prevPath, setPrevPath] = useState<string>(currentPathStart);

	const sectionPage = currentPath.split('/')[1];

	const resetFormStartingValues = useCallback(
		(currentPathStart: string) => {
			switch (currentPathStart) {
				case PATHNAMES.VIEW_CLAIMS:
				case PATHNAMES.CLAIMS_NOTIFICATIONS:
					dispatch(
						setSortingValues({
							name: 'serviceDate,externalClaimId',
							value: `${sortingDirections.DESC},${sortingDirections.DESC}`,
						}),
					);
					break;
				case PATHNAMES.VIEW_PAYMENT_HISTORY:
					dispatch(
						setSortingValues({
							name: 'paymentRunDate',
							value: sortingDirections.DESC,
						}),
					);
					break;
				default:
					dispatch(
						setSortingValues({
							name: '',
							value: '',
						}),
					);
			}

			switch (currentPathStart) {
				case PATHNAMES.VIEW_CLAIMS:
				case PATHNAMES.CLAIMS_NOTIFICATIONS:
					dispatch(setCollection(Collections.CLAIMS));
					break;
				case PATHNAMES.VIEW_PAYMENT_HISTORY:
					dispatch(setCollection(Collections.PAYMENTS));
					break;
				default:
					dispatch(setCollection(Collections.NONE));
			}

			switch (currentPathStart) {
				case PATHNAMES.VIEW_CLAIMS:
					dispatch(setSubCollection(SubCollections.CLAIMS));
					break;
				case PATHNAMES.CLAIMS_NOTIFICATIONS:
					dispatch(setSubCollection(SubCollections.NOTIFICATION));
					break;
				case PATHNAMES.VIEW_PAYMENT_HISTORY:
					dispatch(setSubCollection(SubCollections.PAYMENTS));
					break;
				default:
					dispatch(setSubCollection(SubCollections.NONE));
			}
		},
		[dispatch],
	);

	useEffect(() => {
		const currentPathStart = window.location.pathname.split('/')[1];
		resetFormStartingValues(currentPathStart);
	}, [resetFormStartingValues]);

	useEffect(() => {
		return () => {
			const currentPathStart = window.location.pathname.split('/')[1];
			const isCheckSubmit = currentPathStart === PATHNAMES.CHECK_AND_SUBMIT;

			if (currentPathStart === prevPath) {
				return;
			}

			if (isCheckSubmit) {
				return;
			}

			dispatch(resetForm());
			resetFormStartingValues(currentPathStart);

			setPrevPath(currentPathStart);
		};
	}, [currentPath, dispatch, prevPath, resetFormStartingValues]);

	useEffect(() => {
		if (sectionPage !== 'check-and-submit') {
			dispatch(
				handleChange<any>({
					name: 'dateOfService',
					value: null,
				}),
			);
		}
	}, [dispatch, sectionPage]);
};
